var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-redirect"},[_c('div',{staticClass:"message-to-redirect"},[_c('app-heading',{attrs:{"level":"h6"}},[_vm._v(_vm._s(_vm.$t('redirect'))+":")]),_c('p',[_vm._v(_vm._s(_vm.message.redirectUrl))]),_vm._m(0)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"bounce1"}),_c('div',{staticClass:"bounce2"}),_c('div',{staticClass:"bounce3"})])
}]

export { render, staticRenderFns }